import React, { useMemo } from 'react'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useTourDeals } from 'hooks/TourV2/useTourDeals'
import TourDealsTileSkeleton from './TourDealsTileSkeleton'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import TourDealTile from './TourDealTile'
import { rem } from 'polished'

const DealsHeaderGrid = styled.div`
  > div {
    grid-template-rows: 1fr 1fr 1fr;

    ${mediaQueryUp.tablet} {
      grid-template-rows: unset;
    }
  }
`

const HeaderSection = styled(LayoutContainer)`
  margin-bottom: ${rem(16)};

  ${mediaQueryUp.tablet} {
    margin-bottom: ${rem(24)};
  }
`

const HeaderActionButton = styled(TextButton).attrs({
  size: 'small' as const,
  verticalOutdent: 'start' as const,
})`
  align-self: flex-start;
`

function TourDealsTileCarousel() {
  const [deals, fetching] = useTourDeals()
  const dealSlugs = useMemo(() => {
    if (!deals) {
      return []
    }
    return Object.keys(deals)
  }, [deals])

  if (!fetching && dealSlugs.length === 0) {
    return null
  }

  return <Group direction="vertical" id="deals-carousel">
    <HeaderSection>
      <DealsHeaderGrid>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="start">
          <div>
            <Heading as="h2" variant="heading2">
              Discover our exclusive tour <i>collections</i>
            </Heading>
          </div>
          <HeaderActionButton kind="tertiary" to="/search/tours">
            View all
          </HeaderActionButton>
        </Group>
      </DealsHeaderGrid>
    </HeaderSection>
    {!fetching &&
      <FullWidthCarouselWithAnalytics snap="start">
        {dealSlugs.map((slug) => <TourDealTile
          key={slug}
          slug={slug}
        />)}
      </FullWidthCarouselWithAnalytics>}
    {fetching && <TourDealsTileSkeleton />}
  </Group>
}

export default TourDealsTileCarousel
